import * as React from 'react';

var InlineError = function InlineError(_ref) {
    var children = _ref.children,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        title = _ref.title;
    return React.createElement(
        'div',
        {
            className: 'inline-alert inline-alert-visible inline-alert-error ' + className
        },
        React.createElement(
            'b',
            null,
            title
        ),
        React.createElement(
            'div',
            null,
            children
        )
    );
};

InlineError.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,

    /** Title of the inline error. */
    title: PropTypes.node.isRequired
};
export default InlineError;
import PropTypes from 'prop-types';